import React, { useRef, useCallback, useEffect, useState } from 'react';



const ModalVideoSobre = ({ isOpen, closeModal, urlVideo, titulo }) => {



    if (!isOpen) return null;

    return (
        <>
            <div className="_ngcontent-ng-c485834739 _nghost-ng-c798911410">

                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="video-modal-title"
                    className="video-modal"
                >

                    <section className="video-modal__panel video-modal__panel_youtube_on">

                        <button
                            type="button"
                            aria-label="Cerrar video"
                            onClick={closeModal}
                            className="video-modal__close"
                        >
                            ✕
                        </button>

                        <header className="video-modal__header">
                            <h2 id="video-modal-title" className="video-modal__title">
                                {titulo}
                            </h2>
                        </header>

                        <div className="video-modal__body">

                            <div className="video-modal__content">

                                <div className="video-modal__player-frame">

                                    <iframe
                                        className="video-modal__player"
                                        src={urlVideo}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />

                                </div>

                            </div>

                        </div>
                    </section>

                </div>

            </div>
        </>
    );
};

export default ModalVideoSobre;

{/*}import "./modalVideo.css";


const ModalVideoSobre = ({ isOpen, closeModal, urlVideo }) => {
    if (!isOpen) return null;
    return (
        <div className="modal">
            <div className="modalContent">
                <div className="div_otro">
                    <iframe
                        className="iframeVideo"
                        src={`${urlVideo}?autoplay=1`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
                <button
                    className="botonPop"
                    onClick={() => {
                        closeModal();
                    }}
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="background_gri"></div>
        </div>
    );
};
export default ModalVideoSobre;*/}
